import { render, staticRenderFns } from "./LuAgencyRoleObject.vue?vue&type=template&id=3bcc88a1"
import script from "./LuAgencyRoleObject.vue?vue&type=script&lang=js"
export * from "./LuAgencyRoleObject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports